module.exports = __webpack_public_path__ + "img/foro1.4e62dd79.jpg";